<script lang="ts">
    import { scale } from "svelte/transition";

    interface Params {
        showModal?: boolean;
        header?: Snippet;
        body?: Snippet;
        footer?: Snippet;
        size?: string;
    }

    import type { Snippet } from 'svelte';

    let { showModal = $bindable(), header, body, footer, size }: Params = $props();
    let dialog = $state<HTMLDialogElement>();

    $effect(() => {
        if (showModal) {
            dialog?.showModal();
        } else {
            dialog?.close();
        }
    });

    function closeModal() {
        showModal = false;
    }

</script>

<dialog in:scale out:scale
        bind:this={dialog}
        onclose={closeModal}
        onclick={(e) => { if (e.target === dialog) closeModal() }}
        class="{size} overflow-visible"
>
    <div class="overflow-auto">
        <a href={'#'} style="position: absolute; color: red; top: 5px; right: 10px; text-decoration: none; font-size: 1.2rem" onclick={(e) => { e.preventDefault(); closeModal() }}>&#10006;</a>
        {@render header?.()}
        {@render body?.()}
        {@render footer?.()}
    </div>
</dialog>

<style lang="scss">
  dialog {
    width: 100%;
    max-width: 500px;
    border-radius: 0.2em;
    border: none;
    padding: 0;

    &::backdrop {
      background: rgba(0, 0, 0, 0.3);
    }

    &[open] {
      animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

      &::backdrop {
        animation: fade 0.2s ease-out;
      }
    }

    & > div {
      padding: 1em;
    }

    &.lg {
      max-width: 800px;
    }

    &.xl {
      max-width: 1200px;
    }

    &.xxl {
      max-width: 100%;
      height: 100vh;
      max-height: none;

      > div {
        height: 100%;
        max-height: none;
        overflow: hidden;
        padding: 0.5em;
        box-sizing: border-box;
      }
    }
  }
</style>